import React, { PureComponent } from 'react'
import { Link } from 'react-router'
import { setLanguage } from 'app/Translate'

export default class Spanish extends PureComponent {
  componentWillMount() {
    setLanguage('es')
  }

  render() {
    return (
      <div>
        <Link to='/'>English</Link>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./es.js
 **/